module.exports = __webpack_public_path__ + "static/media/negative.52879d33.png";